export default "__VITE_ASSET__BItRo5nK__"